<template>
  <div>
    <nav-header v-bind:showSearch="p_showSearch" v-bind:loginModalFlag="p_loginModalFlag" v-on:showLoginModal="p_showLoginModal" v-on:closeLoginModal="p_closeLoginModal"></nav-header>
    <nav-bread ref="child"></nav-bread>
    <div class="all-medicines">
            <div class="medicines">
              <p class="title">药品</p>
              <p class="subTitle">全部商品</p>
            </div>
            <ul class="search_ul medicines-list">
                <li @click="gotoDetails(item.id)" v-for="(item, index) in medList" :key="index">
                    <img width="220" height="160" :src="item.src">
         			<div class="msgs info">
         			  <strong><b>{{item.name}}</b>
                          <i class="icon1">OTC</i>
                          <i class="icon2">基</i>
                      </strong>
         			  <p><font>[生产厂商]：</font><span>{{item.company}}</span></p>
         			  <p><font>[用法用量]：</font>{{item.usage}}</p>
         			  <p><font>[功效主治]：</font>{{item.functions}}</p>
         			  <p><font>[药剂类型]：</font>{{item.type}}</p>
         			</div>
                </li>
            </ul>
       </div>
  </div>

</template>

<script>
  import axios from 'axios'
  import "./../assets/css/base.css";
  import "@/assets/css/product.css";
  import "@/assets/css/index.css?version=1.0.1";
  import NavHeader from "@/components/Header.vue";
  import NavFooter from "@/components/Footer.vue";
  import NavBread from "@/components/Bread.vue";
  import {getCookie} from "@/util/util.js"
  import 'babel-polyfill'

  import {medicinesData} from '@/util/medicines.js'

  export default {
    name: "Medicines",
    data() {
      return {
          p_showSearch: true,
          p_loginModalFlag: false,
          hasMoreData: true,
          changes: '',
          inspectionList:[],
          cooperationLIst:[],
          providerType: this.$route.query.providerType,
          medList: medicinesData()
      };
    },
    components: {
      NavHeader,
      NavFooter,
      NavBread
    },
    computed: {
      token(){
        return getCookie("_token")?getCookie("_token"):""
      },
       user() {
        return this.$store.state.user;
      }
    },
    mounted(){
      this.changes = getCookie("_token")?"already":""
      // this.getCooperationLIst( )
    },
    methods: {
        gotoDetails(id) {
            // this.$router.push('/med/${id}')
            console.log(id)
            this.$router.push({
              path: 'med',
              query: {
                id: id
              }
            })
        },
        p_showLoginModal() {
          this.p_loginModalFlag = true;
        },
        p_closeLoginModal() {
          this.p_loginModalFlag = false;
        },
        toSearch(itemName, id) {
          this.$router.push({
            path: "search",
            query: {
              id: id,
              name: itemName
            }
          });
        },

      toInsep() {
        if(getCookie("_token")){
          this.changes ="already"
        }else{
          this.p_showLoginModal()
        }
      },

    },
    watch: {
      'token': function(newVal){
        this.changes = newVal?"already":""
      }
    }
  };
</script>

<style scoped >
.all-medicines {
    width: 75%;
    padding: 0 10px;
    margin: 0 auto;
    margin-top: 28px;
}

.medicines p {
    color: #605F5F;
    box-sizing: border-box;
}

.medicines .title {
   height: 41px;
   line-height: 40px;
   font-weight: 700;
   font-size: 17px;
   width: 50px;
   border-top: 2px solid #00C4AA;
}

.medicines .subTitle {
   height: 46px;
   line-height: 46px;
   color: #00C4AA;
   font-size: 16px;
   border-top: 2px solid #00C4AA;
   width: 100%;
   text-align: left;
   text-indent: 15px;
   font-weight: normal;
}

.medicines-list {
   width:100%;
   padding-bottom: 50px;
}

.medicines-list li {
   display: flex;
   overflow:hidden;
   padding:20px 0;
   border-bottom:1px dotted #E6E6E6;
}

.medicines-list li:hover {
   box-shadow: 0 0 10px #00C4AA;
   cursor: pointer;
   background:#fbfbfb;
}

.medicines-list li img:hover {
   opacity:0.75;
}

.medicines-list li img {
   width:200px;
   height:145px;
   border:1px solid #E1EAF0;
}

.medicines-list li .info {
   width: 100%;
   margin-left:15px;
   text-align: left;
}

.info strong {
   display:block;
   height:24px;
   font-weight:normal;
   font-size:14px;
   line-height:18px;
   line-height:20px\9;
}

.info strong b {
    color: #888;
    font-size: 15px;
}


.info p {
   width:100%;
   overflow:hidden;
   line-height:23px;
   white-space:nowrap;
   text-overflow:ellipsis;
   color:#777;
}

.info p span {
   font-size: 16px;
   font-weight: bold;
}

.info p font {
   margin-right:6px; font-size:12px; color:#444;
}

.info i {
   margin-left: 6px;
   font-size: 12px;
   border-radius: 3px;
   padding: 1px 2px;
}

.icon1 {
   border: 1px solid #EB5B5B;
   color: #EB5B5B;
}

.icon2 {
   border: 1px solid #81C052;
   color: #81C052;
}
</style>



// WEBPACK FOOTER //
// src/pages/Medicines.vue